export class UserMetricInfo {
    public static extractFromProfile(userProfile: any) {
        return new UserMetricInfo(
            userProfile.longTermGoal,
            userProfile.useImperialUnit,
            userProfile.height,
            userProfile.weight,
        );
    }
    constructor(
        public longTermGoal: string,
        public useImperialUnit: boolean,
        public height: number,
        public weight: number,
    ) { }
}
